import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-261a4e6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, reactive } from "vue";
import api from "@/api/system/roles";
import menu from "@/api/system/auth";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
export default {
  __name: 'menuPermissions',
  setup(__props, {
    expose: __expose
  }) {
    const {
      t
    } = useI18n();
    const showDialog = ref(false);
    const params = reactive({
      roleId: "",
      // 角色id
      list: [] // 权限id
    });
    const treeRef = ref(null);
    const loading = ref(false);
    const treeLoading = ref(false);
    const open = row => {
      showDialog.value = true;
      params.roleId = row.id;
      getMenu();
      getPermissionsRolesList(row.id);
    };
    const list = ref([]);
    // 获取该角色权限列表
    const getPermissionsRolesList = async roleId => {
      const {
        data
      } = await api.roleAuthList({
        roleId
      });
      params.list = data.data.list;
    };
    const handleCheck = data => {
      // 获取当前节点是否被选中
      const isChecked = treeRef.value.getNode(data).checked;
      // 如果当前节点被选中，则遍历下级子节点并选中，如果当前节点取消选中，则遍历下级节点并取消
      if (isChecked) {
        // 判断该节点是否有下级节点，如果有那么遍历设置下级节点为选中
        data.children && data.children.length && setChildrenChecked(data.children, true);
      } else {
        // 如果节点取消选中，则取消该节点下的子节点选中
        data.children && data.children.length && setChildrenChecked(data.children, false);
      }
      const ids = treeRef.value.getCheckedKeys();
      params.list = ids;
    };
    const setChildrenChecked = (node, isChecked) => {
      node.forEach(item => {
        item.children && item.children.length && setChildrenChecked(item.children, isChecked);
        // // 修改勾选状态
        treeRef.value.setChecked(item.id, isChecked, false);
      });
    };
    const checkChange = data => {
      // 选中全部子节点，父节点也默认选中，但是子节点再次取消勾选或者全部子节点取消勾选也不会影响父节点勾选状态
      let checkNode = treeRef.value.getNode(data); //获取当前节点
      // 勾选部分子节点，父节点变为半选状态
      if (checkNode.parent && checkNode.parent.childNodes.some(ele => ele.checked)) {
        checkNode.parent.indeterminate = true;
      }
      // 勾选全部子节点，父节点变为全选状态
      if (checkNode.parent && checkNode.parent.childNodes.every(ele => ele.checked)) {
        checkNode.parent.checked = true;
        checkNode.parent.indeterminate = false;
      }
      // 如果取消所有第二节点的勾选状态，则第一层父节点也取消勾选
      if (checkNode.level == 2 && checkNode.parent.childNodes.every(ele => !ele.checked)) {
        checkNode.parent.checked = false;
        checkNode.parent.indeterminate = false;
      }
    };
    const handleClose = () => {
      showDialog.value = false;
    };
    const handleConfig = async () => {
      loading.value = true;
      await api.updateRoleAuth(params);
      ElMessage.success(t("action.success"));
      loading.value = false;
      handleClose();
    };
    // 获取菜单列表
    const getMenu = async () => {
      treeLoading.value = true;
      const {
        data
      } = await menu.menuList();
      list.value = data.data.list;
      treeLoading.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        width: "40%",
        title: _ctx.$t('roles.table.menuPermissions')
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleClose,
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleConfig
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: params,
          size: "large",
          "label-width": "90px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('roles.table.menuPermissions')
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_tree, {
              ref_key: "treeRef",
              ref: treeRef,
              "check-strictly": "",
              onCheck: handleCheck,
              onCheckChange: checkChange,
              "default-checked-keys": params.list,
              "default-expanded-keys": params.list,
              data: list.value,
              "show-checkbox": "",
              "node-key": "id",
              class: "tree",
              props: {
                label: 'name',
                children: 'children'
              }
            }, null, 8, ["default-checked-keys", "default-expanded-keys", "data"]), [[_directive_loading, treeLoading.value]])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};